// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { CardContentProps } from '../CardContentType';
import RouteBuilder from '@Services/RouteBuilder';
import StreamCard from '@Organisms/LiveStreamData/StreamCard/StreamCard';
import { PropRender } from '@Organisms/LiveStreamData/PropRenderer/PropRenderer';
import { ICONS } from '@Constants/iconsApp';
import { useLocalMessage } from '@Helpers/locale';

export const CaseContent = ({ data, base }: CardContentProps): ReactElement => {
    const local = useLocalMessage();
    const { title, description, _id, tags } = data || {};
    const { action, details, object = {} } = base;
    const detailsCreated = {
        tags,
        description,
    };

    let path;
    let titleCard;

    if (details?.number === undefined && object?.number === undefined) {
        titleCard = local('stream.card.case.delete');
    } else {
        titleCard =
            action === 'delete'
                ? `#${details?.number} - ${object?.title ?? details?.title}`
                : `#${object?.number ?? details?.number} - ${title ?? details?.title}`;
        path = RouteBuilder.compute('cases.details', { caseId: _id });
    }

    return (
        <StreamCard icon={<ICONS.CaseIcon />} title={titleCard} path={path} base={base}>
            {action === 'create' &&
                Object.entries(detailsCreated).map(([key, value]) => (
                    <PropRender key={_id + key} prop={key} value={value} type="case" />
                ))}

            {action === 'update' &&
                Object.entries(details).map(([key, value]) => (
                    <PropRender key={_id + key} prop={key} value={value} type="case" />
                ))}
        </StreamCard>
    );
};
